/*  NailHandy — đổi bộ sưu tập của khối "xoay vòng" theo từng lượt tải trang.
 *
 *  Vì sao cần JavaScript: Shopify đệm kết quả dựng Liquid ở phía máy chủ khoảng một phút,
 *  và tham số URL không phá được lớp đệm đó. Đã đo: 8 lần gọi với URL khác nhau trong 9 giây
 *  đều trả về cùng một bộ. Nên máy chủ chỉ dựng được bản nền; muốn đổi mỗi lượt tải thì
 *  phải bốc lại ở trình duyệt.
 *
 *  Cách làm: bốc ngẫu nhiên một handle khác handle đang hiển thị, gọi lại đúng section đó
 *  qua Section Rendering API trên URL bộ sưu tập vừa bốc, rồi thay cả khối.
 *  Khối này nằm dưới màn hình đầu nên khách không kịp thấy lúc thay.
 *
 *  Tắt JavaScript hoặc gọi hỏng => giữ nguyên bản máy chủ đã dựng. Không bao giờ để trống.
 */
(function () {
  'use strict';

  function doiMotKhoi(el) {
    var pool = (el.getAttribute('data-nh-rotate') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var dangHien = el.getAttribute('data-nh-current') || '';
    var sectionId = el.getAttribute('data-nh-section') || '';
    if (pool.length < 2 || !sectionId) return;

    // Loại bộ máy chủ vừa dựng VÀ bộ khách vừa xem ở lần tải trước.
    // Máy chủ bị đệm nên gần như luôn trả về cùng một bộ; nếu chỉ loại mỗi nó thì
    // hai lần tải liên tiếp vẫn có thể bốc trúng nhau.
    var vuaXem = '';
    try { vuaXem = sessionStorage.getItem('nh_rotate_' + sectionId) || ''; } catch (e) {}

    var conLai = pool.filter(function (h) { return h !== dangHien && h !== vuaXem; });
    if (!conLai.length) conLai = pool.filter(function (h) { return h !== dangHien; });
    if (!conLai.length) return;
    var chon = conLai[Math.floor(Math.random() * conLai.length)];
    try { sessionStorage.setItem('nh_rotate_' + sectionId, chon); } catch (e) {}

    var goc = el.closest('.shopify-section');
    if (!goc) return;

    fetch('/collections/' + encodeURIComponent(chon) + '?section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var moi = new DOMParser().parseFromString(html, 'text/html').body.firstElementChild;
        if (!moi || !moi.querySelector('[data-nh-rotate]')) return; // trả về lạ thì thôi, giữ bản cũ
        goc.replaceWith(moi);
        // Báo cho bộ điều phối băng trượt biết có khối mới để gắn lại.
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
      })
      .catch(function () { /* giữ nguyên bản máy chủ đã dựng */ });
  }

  function chay() {
    document.querySelectorAll('[data-nh-rotate]').forEach(doiMotKhoi);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }
})();
